import { APP_CONFIG } from "../constants/global-variables.js";

export async function mybets(startDate, endDate, currency, bet_status) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/mybets`;

  try {
    const res = await axios.post(url, {
      start_date: startDate,
      end_date: endDate,
      currency,
      bet_status
    },{
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}
